import * as React from 'react';
import {
    personaCardBehavior,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';

@personaCardBehavior
export class LivePersonaCardWrapper extends React.Component<
    PersonaCardBehaviorProps,
    React.ComponentState
> {
    render(): any {
        return (
            <div
                className={this.props.className}
                onClick={this.props.onPersonaCardBehaviorClick}
                onMouseEnter={this.props.onPersonaCardBehaviorMouseEnter}
                onMouseLeave={this.props.onPersonaCardBehaviorMouseLeave}>
                {this.props.children}
            </div>
        );
    }
}
